import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageDescription,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { Alert403 } from "@/shared/components/alerts/alert-403";
import t from "../../../../lang/lang";
import { BranchMatching } from "@/services/backend/dynamics/components/branch-matches";
import { ServiceKindMatching } from "@/services/backend/dynamics/components/process-kind-matches";
import { CompanyMatching } from "@/services/backend/dynamics/components/company-matches";

export default function MatchesRoute() {
  const canAccess = useFeatureAuth("dynamics.matches");
  if (!canAccess) {
    return (
      <BaseDataPage>
        <Alert403 />
      </BaseDataPage>
    );
  }

  return (
    <BaseDataPage>
      <BaseDataPageHeader>
        <BaseDataPageTitle>{t("Verknüpfungen")}</BaseDataPageTitle>
        <BaseDataPageDescription>
          {t(`
            Hier können die notwendigen Verknüpfungen zwischen Entitäten des GSM und MS Dynamics vorgenommen werden.
            Im generellen gilt, dass ohne eine Verknüpfung keine entsprechend Daten zwischen den Systemen ausgetauscht 
            werden können.
            `)}
        </BaseDataPageDescription>
      </BaseDataPageHeader>
      <BaseDataPageContent className="space-y-8">
        <CompanyMatching />
        <BranchMatching />
        <ServiceKindMatching />
      </BaseDataPageContent>
    </BaseDataPage>
  );
}
